import { SessionModel } from './session.model';
import { DateUtil } from '../../../core';
import { SessionContext, SessionGuests } from './session.interface';
import { LocalStorage } from '../../../core/local-storage';
import { PROMOCODE_KEY } from './session';

const getTotalGuests = (session: SessionModel): number => {
  return getGuestsCount(session?.context.guests) || 0;
};

export const getGuestsCount = (guests: SessionGuests) => {
  if (!guests) {
    return;
  }
  return Object.keys(guests).reduce(
    (acc, guestKey) => acc + guests[guestKey as keyof typeof guests],
    0,
  );
};

const getSessionOccupancy = (session: SessionModel) => {
  return session?.context.guests;
};

const formatArrivalDate = (session: SessionModel) => {
  const stayPeriod = session.context.stayPeriod;
  const language = session.display.culture;
  const arrivalDate = DateUtil.removeTimeFromDate(
    new Date(stayPeriod.arrivalDate),
  );
  return DateUtil.formatCalendarDate(arrivalDate, language);
};

const formatDepartureDate = (session: SessionModel) => {
  const stayPeriod = session.context.stayPeriod;
  const language = session.display.culture;
  const departureDate = DateUtil.removeTimeFromDate(
    new Date(stayPeriod.departureDate),
  );
  return DateUtil.formatCalendarDate(departureDate, language);
};

const formatStayPeriod = (session: SessionModel) => {
  return `${formatArrivalDate(session)} - ${formatDepartureDate(session)}`;
};

const getNumberOfNights = (session: SessionModel) => {
  return DateUtil.getAllPossibleStayPeriod(session.context.stayPeriod).length;
};

const addPromoCodeFromLocalStorage = (sessionContext?: SessionContext) => {
  const promoCode =
    sessionContext?.promoCode || LocalStorage.get(PROMOCODE_KEY);
  const updatedSessionContext = promoCode
    ? { ...sessionContext, promoCode }
    : { ...sessionContext };
  return updatedSessionContext;
};

const addPromoCodeFromSessionStorage = (sessionContext?: SessionContext) => {
  const promoCode =
    sessionContext?.promoCode || sessionStorage.getItem(PROMOCODE_KEY);
  const updatedSessionContext = promoCode
    ? { ...sessionContext, promoCode }
    : { ...sessionContext };
  return updatedSessionContext;
};

export const SessionHelper = {
  getTotalGuests,
  getSessionOccupancy,
  formatStayPeriod,
  formatArrivalDate,
  formatDepartureDate,
  getNumberOfNights,
  addPromoCodeFromLocalStorage,
  addPromoCodeFromSessionStorage,
  getGuestsCount,
};
